import { DesktopSettings } from '@honestica/electron-bridge-typing';
import { electronService } from '@services/electron/electron.service';
import { i18n } from '@services/i18n/index';
import { logger } from '@services/logger/logger.service';

export async function addVirtualPrinterForMac(settings: DesktopSettings) {
  try {
    const osPlatform = await electronService.getPlatform();
    if (osPlatform !== 'darwin') return;

    // Desktop apps older than 200.5.17 do not expose ensureVirtualPrinterLink.
    if (typeof window.electron?.ensureVirtualPrinterLink !== 'function') {
      logger.warn('DESKTOP', 'ensureVirtualPrinterLink not available, skipping virtual printer');
      return;
    }

    logger.info('DESKTOP', 'Mac platform detected, ensuring virtual printer...');

    const folderName =
      settings.printerFolderName || i18n.t('settings.virtualPrinter.folderNameDefault') || '';

    const created = await electronService.ensureVirtualPrinterLink(folderName);
    if (created) {
      logger.info('DESKTOP', 'Virtual printer symlink ensured', { folderName });
    }
  } catch (error) {
    logger.error('DESKTOP', 'Cannot verify if virtual printer has been installed', error);
  }
}
